module.exports = __webpack_public_path__ + "img/img05.f8bebd35.png";